var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFocus = function SvgFocus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "focus_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#focus_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#004152"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 18.5a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5ZM16 23.25a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0ZM9.25 6.5A2.75 2.75 0 0 0 6.5 9.25v4a1.25 1.25 0 1 1-2.5 0v-4A5.25 5.25 0 0 1 9.25 4h4a1.25 1.25 0 1 1 0 2.5h-4ZM32 5.25c0-.69.56-1.25 1.25-1.25h4a5.25 5.25 0 0 1 5.25 5.25v4a1.25 1.25 0 1 1-2.5 0v-4a2.75 2.75 0 0 0-2.75-2.75h-4c-.69 0-1.25-.56-1.25-1.25ZM41.25 32c.69 0 1.25.56 1.25 1.25v4a5.25 5.25 0 0 1-5.25 5.25h-4a1.25 1.25 0 1 1 0-2.5h4A2.75 2.75 0 0 0 40 37.25v-4c0-.69.56-1.25 1.25-1.25ZM5.25 32c.69 0 1.25.56 1.25 1.25v4A2.75 2.75 0 0 0 9.25 40h4a1.25 1.25 0 1 1 0 2.5h-4A5.25 5.25 0 0 1 4 37.25v-4c0-.69.56-1.25 1.25-1.25Z"
  }))));
};
export default SvgFocus;